import './App.css';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Player from './Player';
import Inicial from './Inicial';
import Context from './Context';
import Todas from './Todas';
import MenuPc from './MenuPc';
import Header from './Header';
import MenuCel from './MenuCel';
import NewNote from './NewNote';
import Animacao from './Animacao';

function App() {
  const [iniciando,setIniciando]=useState(true)
  const [fade, setFade] = useState(false)

  const [mostrandoTodas,setMostrandoTodas]=useState(false)
  const [id,setId]=useState(false)
  const [tempo,setTempo]=useState(false)
  const [menu,setMenu]=useState(false)
  const [videos,setVideos]=useState(JSON.parse(localStorage.getItem(`videos`))||[])
  const [notas,setNotas]=useState(JSON.parse(localStorage.getItem(`notas`))||[])
  const valorContexto={
    menu,setMenu,
    tempo,setTempo,mostrandoTodas,setMostrandoTodas,
    id,setId,videos,setVideos,notas,setNotas
  }
  useEffect(()=>{
    localStorage.setItem(`videos`, JSON.stringify(videos))
  },[videos])
  useEffect(()=>{
    localStorage.setItem(`notas`, JSON.stringify(notas))
  },[notas])
  
  useEffect(() => {
  const timer1 = setTimeout(() => {setFade(true) }, 1000)
  const timer2 = setTimeout(() => {setIniciando(false) }, 1500) 
  return () => {
    clearTimeout(timer1)
    clearTimeout(timer2)
  }
}, [])
  return (
    <Context.Provider value={valorContexto}>
       <BrowserRouter>
       {iniciando?<Animacao fade={fade}/>:<></>}
       <Routes>
        <Route path='/' element={
       <Tudo>
        
          <Header />
          {menu?<MenuCel/>:
          <Resto>
            {mostrandoTodas?<Todas/>:
              id?<Player/>:<Inicial/>}
              <MenuPc telona={true} />
          </Resto>}
        </Tudo>
        }/>
            <Route path='/point/:id/:num/:texto' element={<NewNote/>}/>
          </Routes>
      </BrowserRouter>
      
    </Context.Provider>
    
  );
}

const Tudo=styled.div`
flex-direction:column;
display:flex;
width:100vw;
height:100vh;
background:#2a2a3f;
div{
box-sizing:border-box;
display:flex;
}
overflow:auto;
`
const Resto=styled.div`
width:100%;
height:calc(100% - 60px);
background:#2a2a3f;
overflow:auto;
`

export default App;
